<template>
  <div class="localization__container">
    <div class="localization_container">
      <div class="localization_header">Localization</div>
      <div class="localization_heade-width">
        <div class="localization_home">Home</div>
        <div class="localization_home_text">Your home screen settings</div>
        <div class="localization_home_flex">
          <div class="localization_home_block">
            <div class="localization_home_desc">Home:</div>
            <InputWebsite class="localization_input" placeholder="Home" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Start a conversation:</div>
            <InputWebsite
              class="localization_input"
              placeholder="Start a conversation"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Starting:</div>
            <InputWebsite class="localization_input" placeholder="Starting:" />
          </div>
        </div>
      </div>
    </div>
    <div class="localization_container">
      <div class="localization_container_messages">
        <div class="localization_header">Messages</div>
        <div class="messages_text">Your messages screen settings</div>
      </div>
      <div class="localization_heade-width">
        <div class="messages_home_flex">
          <div class="localization_home_block">
            <div class="localization_home_desc">Messages:</div>
            <InputWebsite class="localization_input" placeholder="Messages" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">No Messages:</div>
            <InputWebsite
              class="localization_input"
              placeholder="No Messages"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">
              Verify your email to see your conversation history:
            </div>
            <InputWebsite
              class="localization_input"
              placeholder="Verify your email to see your conversation history"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">
              Your conversation history shows up here:
            </div>
            <InputWebsite
              class="localization_input"
              placeholder="Your conversation history shows up here"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Verify your email:</div>
            <InputWebsite
              class="localization_input"
              placeholder="Verify your email"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Start a conversation:</div>
            <InputWebsite
              class="localization_input"
              placeholder="Start a conversation"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Starting...</div>
            <InputWebsite
              class="localization_input"
              placeholder="Starting..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="localization_container">
      <div class="localization_container_messages">
        <div class="localization_header">Messages</div>
        <div class="messages_text">Your indiviual conversation settings</div>
      </div>
      <div class="localization_heade-width">
        <div class="messages_home_flex">
          <div class="localization_home_block">
            <div class="localization_home_desc">Bot:</div>
            <InputWebsite class="localization_input" placeholder="Bot" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">You:</div>
            <InputWebsite class="localization_input" placeholder="You" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Agent:</div>
            <InputWebsite class="localization_input" placeholder="Agent" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">
              Are you sure you want to escalate the chat to human support?
            </div>
            <InputWebsite
              class="localization_input"
              placeholder="Are you sure you want to escalate the chat to..."
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">
              This conversation will be shared with the human support and they
              will get back to you as soon as they can.
            </div>
            <InputWebsite
              class="localization_input"
              placeholder="This conversation will be shared with the human..."
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Yes, continue:</div>
            <InputWebsite
              class="localization_input"
              placeholder="Yes, continue"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Cancel:</div>
            <InputWebsite class="localization_input" placeholder="Cancel" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">
              👨‍💼 Conversation changed to human mode:
            </div>
            <InputWebsite
              class="localization_input"
              placeholder="👨‍💼 Conversation changed to human mode"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="localization_container">
      <div class="localization_container_messages">
        <div class="localization_header">Account</div>
        <div class="messages_text">Your account screen settings</div>
      </div>
      <div class="localization_heade-width">
        <div class="messages_home_flex">
          <div class="localization_home_block">
            <div class="localization_home_desc">Account:</div>
            <InputWebsite class="localization_input" placeholder="Account" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Verify your email:</div>
            <InputWebsite
              class="localization_input"
              placeholder="Verify your email"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">
              Verify your email to view your chat history:
            </div>
            <InputWebsite
              class="localization_input"
              placeholder="Verify your email to view your chat history"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Email</div>
            <InputWebsite class="localization_input" placeholder="Email" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Name</div>
            <InputWebsite class="localization_input" placeholder="Name" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Phone Number</div>
            <InputWebsite
              class="localization_input"
              placeholder="Phone Number"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Submit</div>
            <InputWebsite class="localization_input" placeholder="Submit" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Sending OTP...</div>
            <InputWebsite
              class="localization_input"
              placeholder="Sending OTP..."
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Verify OTP</div>
            <InputWebsite class="localization_input" placeholder="Verify OTP" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">
              We sent the OTP to your email address
            </div>
            <InputWebsite
              class="localization_input"
              placeholder="We sent the OTP to your email address"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">OTP</div>
            <InputWebsite class="localization_input" placeholder="OTP" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Verify & Continue</div>
            <InputWebsite
              class="localization_input"
              placeholder="Verify & Continue"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Didn't receive OTP yet?</div>
            <InputWebsite
              class="localization_input"
              placeholder="Didn't receive OTP yet?"
            />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">Resend</div>
            <InputWebsite class="localization_input" placeholder="Resend" />
          </div>
          <div class="localization_home_block">
            <div class="localization_home_desc">
              Edit Details/div>
              <InputWebsite
                class="localization_input"
                placeholder="Edit Details"
              />
            </div>
            <div class="localization_home_block">
              <div class="localization_home_desc">Resetting...</div>
              <InputWebsite
                class="localization_input"
                placeholder="Resetting..."
              />
            </div>
            <div class="localization_home_block">
              <div class="localization_home_desc">Verifying...</div>
              <InputWebsite
                class="localization_input"
                placeholder="Verifying..."
              />
            </div>
            <div class="localization_home_block">
              <div class="localization_home_desc">Logout</div>
              <InputWebsite class="localization_input" placeholder="Logout" />
            </div>
            <div class="localization_home_block">
              <div class="localization_home_desc">Logging out...</div>
              <InputWebsite
                class="localization_input"
                placeholder="Logging out..."
              />
            </div>
            <div class="localization_home_block">
              <div class="localization_home_desc">Verified</div>
              <InputWebsite class="localization_input" placeholder="Verified" />
            </div>
            <div class="localization_home_block">
              <div class="localization_home_desc">Edit</div>
              <InputWebsite class="localization_input" placeholder="Edit" />
            </div>
            <div class="localization_home_block">
              <div class="localization_home_desc">Update</div>
              <InputWebsite class="localization_input" placeholder="Update" />
            </div>
            <div class="localization_home_block">
              <div class="localization_home_desc">Updating...</div>
              <InputWebsite
                class="localization_input"
                placeholder="Updating..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputWebsite from "../../components/shared/InputWebsite.vue";
export default {
  components: {
    InputWebsite,
  },
};
</script>
<style scoped>
.localization_header {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.localization_home {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.messages_home_flex {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.localization_container_messages {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.localization_home_text {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  padding-top: 6px;
  font-weight: 500;
  line-height: 24px;
}
.localization_home_desc {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.localization_container {
  display: flex;
  gap: 61px;
}
.localization_heade-width {
  max-width: 431px;
  width: 100%;
}
.localization_home_block {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.localization__container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 36px;
}
.localization_input {
  max-width: 100% !important;
}
.localization_home_flex {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  gap: 24px;
}
.messages_text {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  max-width: 104px;
  width: 100%;
}
</style>
